import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { useIsMobile } from "@utils/hooks";
import { mobile } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { LastDisbursement } from "./lastDisbursement";
import { LastDisbursementOnMobile } from "./lastDisbursementOnMobile";
import { LastTransactions } from "./lastTransactions";
import { LastTransactionsOnMobile } from "./lastTransactionsOnMobile";
import { ShareroomBalance } from "./shareroomBalance";
import { ShareroomIncome } from "./shareroomIncome";
import { ShareroomMembersCount } from "./shareroomMembersCount";
interface DashboardDealingProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const DashboardDealing: React.FC<DashboardDealingProps> = ({ shareroom, ...htmlProps }) => {
	const { license } = shareroom;
	const isMobile = useIsMobile();

	return (
		<Container {...htmlProps}>
			<StyledCard>
				<StyledShareroomBalance license={license} shareroom={shareroom} />
				<StyledShareroomIncome shareroom={shareroom} />
				<StyledShareroomMembersCount shareroom={shareroom} />
			</StyledCard>
			<ContentBlock>
				{isMobile ? <LastDisbursementOnMobile shareroom={shareroom} /> : <LastDisbursement shareroom={shareroom} />}
			</ContentBlock>
			{isMobile ? <LastTransactionsOnMobile shareroom={shareroom} /> : <LastTransactions shareroom={shareroom} />}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;
const StyledCard = styled.div`
	display: grid;
	grid-template:
		" balance income  member" 1fr
		"main main main" auto;
	gap: 0px 10px;

	@media ${mobile} {
		gap: 20px 0px;
		grid-template:
			"balance" auto
			"income" auto
			"member" auto
			"main" auto;
	}
`;

const StyledShareroomIncome = styled(ShareroomIncome)`
	grid-area: income;
`;

const StyledShareroomBalance = styled(ShareroomBalance)`
	grid-area: balance;
`;

const StyledShareroomMembersCount = styled(ShareroomMembersCount)`
	grid-area: member;
`;
const ContentBlock = styled(RoundedBlock)`
	margin-top: 20px;
	@media ${mobile} {
		margin-top: 0px;
		margin-bottom: 20px;
		padding: 22px;
	}
`;
